/* eslint-disable import/prefer-default-export */
export const LOAD_CARD = 'LOAD_CARD';
export const ACTIVATE_SIDE_BY_ID = 'ACTIVATE_SIDE_BY_ID';
export const ACTIVATE_LAYER_BY_ID = 'ACTIVATE_LAYER_BY_ID';
export const DEACTIVATE_LAYER = 'DEACTIVATE_LAYER';
export const SET_FONT_SIZE = 'SET_FONT_SIZE';
export const SET_LINE_HEIGHT = 'SET_LINE_HEIGHT';
export const SHOW_TOOLTIPS = 'SHOW_TOOLTIPS';
export const HIDE_TOOLTIPS = 'HIDE_TOOLTIPS';
export const TOGGLE_TOOLTIPS = 'TOGGLE_TOOLTIPS';
export const SHOW_PREVIEW = 'SHOW_PREVIEW';
export const REQUEST_PDF = 'REQUEST_PDF';
export const REQUEST_SCREENSHOT_OF_EACH_SIDE = 'REQUEST_SCREENSHOT_OF_EACH_SIDE';
// export const RESET_IMAGE_LAYER_STYLES = 'RESET_IMAGE_LAYER_STYLES';

// local storage
export const LOAD_USER_IMAGES_FROM_LOCAL_STORAGE = 'LOAD_USER_IMAGES_FROM_LOCAL_STORAGE';

// layout editing
export const ACTIVATE_LAYOUT_MODE = 'ACTIVATE_LAYOUT_MODE';
export const DISCARD_LAYOUT_CHANGES = 'DISCARD_LAYOUT_CHANGES';
